import React from "react"
import classnames from "classnames/bind"

import TopTitle from "@components/TopTitle"
import AnchorButton from "@components/CTAAnchorButton"
import styles from "./BannerHome.module.scss"

const Article = props => {
  return (
    <article className={styles.article + " text-center text-lg-left pr-lg-5"}>
      <h1
        className={classnames(
          styles.title,
          "proxima-nova--extra-bold",
          "fs-30pt",
          "text-white",
          "mb-5",
          "fs-lg-40pt",
          "fs-xl-50pt"
        )}
      >
        <TopTitle content="SIMPLICITY, SECURITY AND FLEXIBILITY" /> SELF SERVICE FOR ACCESS REQUESTS
      </h1>
      <p
        className={
          styles.description +
          " fs-18pt fs-xl-23pt text-white proxima-nova--light"
        }
      >
        Let your users request the access they need and delegate approval tasks to the best suited decision makers.
      </p>
      <AnchorButton
        href="/demo"
        content="SEE A DEMO"
        className={styles.button}
      />
    </article>
  )
}

export default Article
